module.exports = __webpack_public_path__ + "static/media/cross-dark.18ddee47.svg";